import { render, staticRenderFns } from "./PracticeMembersList.vue?vue&type=template&id=0b8d3604&scoped=true"
import script from "./PracticeMembersList.vue?vue&type=script&lang=js"
export * from "./PracticeMembersList.vue?vue&type=script&lang=js"
import style0 from "./PracticeMembersList.vue?vue&type=style&index=0&id=0b8d3604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d3604",
  null
  
)

export default component.exports